var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpendCategoryEatingOut32(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DDL-CBA---Icons-Mobile",
    transform: "translate(-1421.000000, -732.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon//SpendCategory/EatingOut32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounding-box",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconEatingOut",
    transform: "translate(8.000000, 3.000000)",
    fill: "#706D6E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "KnifeFork"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.146176,2 C14.1900685,1.98591302 14.2344248,1.97224804 14.2792459,1.95900288 L14,1.99939959 L14.146176,2 Z M11,6.06620221 L11,14.0109863 L13,14.0109863 L13,24 L14,24 L14,2.04907802 C12.2760834,2.65404584 11.3006398,3.94593266 11,6.06620221 Z M13.9958496,1 L15,1 L15,25 L12,25 L12,15.0109863 L10,15.0109863 L10,5.99755859 C10.3558757,3.34790039 11.6878255,1.68204753 13.9958496,1 Z",
    id: "Knife"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fork",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,23 L4,23 L4,6.08105469 L5,6.08105469 C5.77196496,6.08105469 6,5.84377799 6,5 L6,1 L1,1 L1,5 C1,5.81609578 1.22401139,6.04516602 2,6.04516602 L3,6.04516602 L3,23 Z M1.39746663e-14,5 L0,0 L7,0 L7,5 C7,6.38736979 6.33333333,7.08105469 5,7.08105469 L5,24 L2,24 L2,7.04516602 C0.666666667,7.04516602 4.65822208e-15,6.36344401 1.39746663e-14,5 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Left",
    x: 2,
    y: 1,
    width: 1,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Right",
    x: 4,
    y: 1,
    width: 1,
    height: 3
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpendCategoryEatingOut32);
export default __webpack_public_path__ + "static/media/spendCategoryEatingOut32.342c27f8e9fc3b6f13ea66fa8fa894fe.svg";
export { ForwardRef as ReactComponent };